import Axios from 'axios'
import { Message } from 'element-ui'
import { SERVER_API_USER_NEWKMS, SSO_TOKEN } from '@/config'

const notAllowInterceptApis = [
  '/cas/authorize'
]
function handleCode(code, msg) {
  switch (code) {
    case 401: {
      Message.error('无权限访问！请重新登录')
      window.location.replace('/cas/login')
      break
    }
    case 403: {
      Message.error('登录状态错误')
      break
    }
    default: {
      Message.error(msg || `后端接口${code}异常`)
    }
  }
}
function requestFactory(httpClient) {
  httpClient.interceptors.request.use(
    (opts) => {
      const token = window.localStorage.getItem(SSO_TOKEN)
      if (token) {
        /* eslint-disable no-param-reassign */
        opts.headers.Authorization = token
      }
      return opts
    },
    (error) => Promise.reject(error)
  )
}
function responseFactory(httpClient) {
  httpClient.interceptors.response.use(
    (response) => {
      if (response.data.code !== 200) {
        handleCode(response.data.code, response.data.msg)
      }
      return response.data
    },
    (error) => {
      if (notAllowInterceptApis.includes(error.config.url)) {
        return;
      }
      if (!error.response) {
        let { message, status } = error
        if (message === 'Network Error') {
          message = '接口连接异常'
        }
        if (message.includes('timeout')) {
          message = '接口请求超时'
        }
        if (message.includes('Request failed with status code')) {
          const code = message.substr(message.length - 3)
          message = `接口${code}异常`
        }
        handleCode(status, message)
        return Promise.reject({ status: 500, message: error.message })
      }

      const { status, data } = error.response
      const error_info = typeof data === 'string' ? data : data.msg || error.message
      handleCode(status, error_info)
      return Promise.reject({ status, message: error_info })
    }
  )
}

function clientFactory(options = {}) {
  const client = Axios.create(options)
  requestFactory(client)
  responseFactory(client)
  return client
}

const request = clientFactory({
  baseURL: SERVER_API_USER_NEWKMS,
  timeout: 1000 * 300, // 5min
})

export default request
